/* Reliance — « Laissez-vous guider » (section rel-guide).
   La pastille apparaît 1 s après l'ouverture de la page (ou au premier défilement), ouvre le panneau,
   et sa croix / « Ne plus afficher » la masque durablement (localStorage).
   Tout bouton [data-rel-guide-trigger] de la page (ex. « Guidez-moi » de la vue
   catalogue) ouvre le même panneau, y compris s'il est ajouté après coup (clic délégué) ;
   il reste caché tant que le guide est absent. Gabarits exclus (data-rel-guide-panel-only) :
   jamais de pastille, seulement le panneau ouvert par ces boutons. */
(function () {
  var root = document.querySelector('[data-rel-guide]');
  if (!root) return;

  var KEY = 'rel-guide-hidden';
  var editor = root.hasAttribute('data-rel-guide-editor');
  var panel = root.querySelector('[data-rel-guide-panel]');
  var openBtn = root.querySelector('[data-rel-guide-open]');

  // La pastille cookies Axeptio (bas gauche, z-index très élevé) passerait au-dessus
  // du panneau du guide ouvert, du menu mobile et de la barre d'achat des fiches produit :
  // on la masque tant que l'un des trois est affiché.
  var axeptioHiddenBy = { guide: false, menu: false, bar: false };
  var axeptioHidden = false;
  function toggleAxeptioButton(reason, hide) {
    axeptioHiddenBy[reason] = hide;
    var shouldHide = axeptioHiddenBy.guide || axeptioHiddenBy.menu || axeptioHiddenBy.bar;
    if (shouldHide === axeptioHidden) return;
    var fn = shouldHide ? window.hideAxeptioButton : window.showAxeptioButton;
    if (typeof fn === 'function') {
      fn();
      axeptioHidden = shouldHide;
    }
  }

  // Le tiroir du menu (header-drawer, global.js) pose « overflow-hidden-tablet » ou « -desktop » sur <body>.
  new MutationObserver(function () {
    toggleAxeptioButton('menu', /\boverflow-hidden-(tablet|desktop)\b/.test(document.body.className));
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Barre d'achat mobile des fiches produit (rel-pdp.js) ; la pastille du guide remonte au-dessus en CSS.
  document.addEventListener('rel:pdp-bar', function (event) {
    toggleAxeptioButton('bar', event.detail.visible);
  });
  if (document.documentElement.classList.contains('rel-pdp-bar-visible')) toggleAxeptioButton('bar', true);

  function read() {
    try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function write() {
    try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  // Déjà masqué (« Ne plus afficher ») : pas de pastille, mais les boutons
  // « Guidez-moi » des pages ([data-rel-guide-trigger]) ouvrent encore le panneau.
  var dismissed = !editor && (!!read() || root.hasAttribute('data-rel-guide-panel-only'));
  var pillShown = false;
  var lastTrigger = null;
  var hideTimer;
  function triggers() {
    return document.querySelectorAll('[data-rel-guide-trigger]');
  }

  function show() {
    clearTimeout(hideTimer);
    root.hidden = false;
    root.classList.add('is-visible');
  }

  function reveal() {
    window.removeEventListener('scroll', onScroll);
    if (dismissed) return;
    pillShown = true;
    root.classList.remove('is-panel-only');
    show();
  }
  function onScroll() {
    if (window.scrollY > window.innerHeight * 0.4) reveal();
  }

  var armed = false;
  function arm() {
    if (armed) return;
    armed = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.setTimeout(reveal, 1000);
  }

  if (!dismissed) {
    root.hidden = false;

    // Sur téléphone, tant que le bandeau cookies Axeptio attend une réponse, le guide reste caché
    // (le bandeau occupe le bas de l'écran). Dès 750 px, bandeau (bas gauche) et pastille (bas droite) cohabitent.
    // Axeptio se charge en différé et pose « axeptio_cookies » avec $$completed:false dès l'arrivée.
    var consentGiven = /axeptio_cookies=[^;]*completed(?:%22|")\s*(?::|%3A)\s*true/i.test(document.cookie);
    var wideScreen = window.matchMedia('(min-width: 750px)').matches;
    if (editor || consentGiven || wideScreen) {
      editor ? reveal() : arm();
    } else {
      window._axcb = window._axcb || [];
      window._axcb.push(function (sdk) {
        sdk.on('cookies:complete', arm);
      });
      // Sans Axeptio sur la page, ne pas bloquer le guide.
      window.setTimeout(function () {
        if (!window.axeptioSDK) arm();
      }, 20000);
    }
  }

  function setExpanded(open) {
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    triggers().forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setOpen(open, returnFocus) {
    if (open) {
      root.classList.toggle('is-panel-only', !pillShown);
      show();
    }
    panel.hidden = !open;
    root.classList.toggle('is-open', open);
    setExpanded(open);
    toggleAxeptioButton('guide', open);
    if (open) {
      var first = panel.querySelector('a, button');
      if (first) first.focus();
      return;
    }
    // Ouvert depuis un bouton de la page sans que la pastille soit affichée : tout se referme.
    if (!pillShown) {
      root.classList.remove('is-visible');
      hideTimer = window.setTimeout(function () {
        if (dismissed) root.hidden = true;
      }, 400);
    }
    if (returnFocus === false) return;
    var target = lastTrigger || openBtn;
    lastTrigger = null;
    target.focus();
  }

  openBtn.addEventListener('click', function () {
    lastTrigger = null;
    setOpen(panel.hidden);
  });

  triggers().forEach(function (btn) {
    btn.setAttribute('aria-controls', panel.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.hidden = false;
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-rel-guide-trigger]');
    if (!btn) return;
    if (!panel.hidden) {
      setOpen(false);
      return;
    }
    btn.setAttribute('aria-controls', panel.id);
    lastTrigger = btn;
    setOpen(true);
  });

  root.querySelector('[data-rel-guide-close]').addEventListener('click', function () {
    setOpen(false);
  });

  root.querySelectorAll('[data-rel-guide-dismiss]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      write();
      dismissed = true;
      pillShown = false;
      lastTrigger = null;
      panel.hidden = true;
      setExpanded(false);
      toggleAxeptioButton('guide', false);
      root.classList.remove('is-visible', 'is-open');
      hideTimer = window.setTimeout(function () { root.hidden = true; }, 400);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) setOpen(false);
  });

  document.addEventListener('click', function (event) {
    if (panel.hidden || root.contains(event.target)) return;
    if (event.target.closest && event.target.closest('[data-rel-guide-trigger]')) return;
    setOpen(false, false);
  });
})();
